import React, { useState, useEffect, useRef } from "react";
import { JsonApiAdapter } from "commons/JsonApiAdapter";
import { BugsnagAdapter } from "commons/BugsnagAdapter";
import WatchPlaylistEpisodeCard from "components/desktop/watch/WatchPlaylist/WatchPlaylistEpisodeCard";
import WatchPlaylistEpisodeLoadMore from "components/desktop/watch/WatchPlaylist/WatchPlaylistEpisodeLoadMore";

export default function WatchPlaylistEpisodeList({
  playlistId,
  selectedPlaylistId,
  videoId,
  seasonData,
  contentType
}) {
  const MAX_ITEM = 20;
  let episodeListUrl = useRef(getUrlPath(1));
  let initialLoad = useRef(false);

  const [episodeList, setEpisodeList] = useState([]);
  const [loadMoreEpisodes, setLoadMoreEpisodes] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);

  useEffect(() => {
    if (seasonData.id != selectedPlaylistId) {
      return;
    }

    if (initialLoad.current) {
      return;
    }

    fetchData(episodeListUrl.current);

    return function cleanup() {
      initialLoad.current = true;
    };
  }, [selectedPlaylistId]);

  useEffect(() => {
    if (!loadMoreEpisodes) {
      return;
    }

    fetchData(episodeListUrl.current).then(() => setLoadMoreEpisodes(false));

  }, [loadMoreEpisodes]);

  function fetchData(url) {
    return JsonApiAdapter.fetchApi(url)
      .then(handleResponse)
      .catch((e) => {
        BugsnagAdapter.notify(
          "WatchPlaylist::getContentProfilePlaylistItems",
          e
        );
      });
  }

  function getUrlPath(pageNumber) {
    const stringUrl = seasonData.relationships.videos.links.related
    const url = new URL(stringUrl)

    let urlPath = `${url.origin}${url.pathname}`;
    urlPath += `?page[size]=${MAX_ITEM}&page[number]=${pageNumber}`;
    return urlPath;
  }

  function handleResponse(responseData) {
    if (responseData["links"]) {
      const { next: nextUrl } = responseData.links;

      episodeListUrl.current = nextUrl;

      if (nextUrl) {
        setShowLoadMore(true);
      } else {
        setShowLoadMore(false);
      }
    }

    if (responseData && typeof responseData.data === typeof []) {
      setEpisodeList((episodeList) => episodeList.concat(responseData.data));
    }
  }

  return (
    <div
      className={
        seasonData.id == selectedPlaylistId
          ? "watch-playlist-episode-list"
          : "watch-playlist-episode-list hide-me"
      }
    >
      {episodeList.map((episode, position) => (
        <WatchPlaylistEpisodeCard
          isActive={videoId == episode.id}
          episode={episode}
          key={`${playlistId}-${episode.id}`}
          ahoyProps={{
            action: 'click',
            content_type: 'video',
            content_id: parseInt(episode.id),
            content_position: position+1,
            source_content_id: parseInt(videoId),
            section: 'playlist',
            feature: contentType
          }}
        />
      ))}
      {showLoadMore && (
        <WatchPlaylistEpisodeLoadMore
          setLoadMoreEpisodes={setLoadMoreEpisodes}
        />
      )}
    </div>
  );
}
